import React from "react";
/* ASSETS */
/* import mascotte from '../../assets/img/mascotte.svg' */
import { useTranslation } from "react-i18next";
import MyButton from "../components/MyButton";
const ThirdScreen = () => {
  const { t } = useTranslation();
  return (
    <section className="event-s3">
      <h1 dangerouslySetInnerHTML={{ __html: t("event.s3-title") }} />
      <p
        className="event-s3-description"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        dangerouslySetInnerHTML={{ __html: t("event.s3-description") }}
      ></p>
      <MyButton
        link="https://app.mego.tickets/event/d5ec4714-31c1-41bf-8db0-5eef5f64e8fe"
        target="_blank"
        useFade
      >
        {t("home.buttonText")}
      </MyButton>
    </section>
  );
};
export default ThirdScreen;
